import React, { ReactNode } from 'react';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { Box, Divider, Typography } from '@mui/material';
import { ModalCloseIcon } from '../Icons';
import styled from 'styled-components';

interface StyledDrawerProps extends DrawerProps {
	position?: 'left' | 'top' | 'right' | 'bottom';
}

const StyledDrawer = styled(Drawer)<StyledDrawerProps>`
	& .MuiPaper-root {
		display: flex;
		height: ${(props) => props?.style?.height || '100%'};
		border-radius: 8px 0px 0px 8px;
		background: var(--others-white, #fff);
		width: ${(props) => props?.style?.width || '100%'};
		transition: width 0.3s ease-in-out !important;
	}
`;

interface CustomDrawerProps extends DrawerProps {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	header?: boolean;
	title?: string;
	style?: React.CSSProperties;
	position?: 'left' | 'top' | 'right' | 'bottom';
	children?: ReactNode;
	onClose?: any;
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({
	open,
	setOpen,
	header,
	title,
	style,
	position = 'right',
	children,
	onClose,
	...props
}) => {
	const handleClose = onClose
		? () => {
				onClose();
				setOpen(false);
		  }
		: () => {
				setOpen(false);
		  };

	return (
		<StyledDrawer style={style} open={open} onClose={handleClose} anchor={position} {...props}>
			{header ? (
				<>
					<Box
						display="flex"
						justifyContent="space-between"
						alignItems="center"
						p={2}
						width="100%"
						height="56px"
					>
						<Typography variant="body1">{title}</Typography>
						<Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
							<ModalCloseIcon />
						</Box>
					</Box>
					<Divider style={{ width: '100%' }} />
				</>
			) : null}
			{children}
		</StyledDrawer>
	);
};

export default CustomDrawer;
